import { render, staticRenderFns } from "./EventDeleteDialog.vue?vue&type=template&id=77c3da42&"
import script from "./EventDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./EventDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports